/** HUD-Teil: kurze Meldungen (Beute, Stufe, Krümel). */

import type { Ereignis } from '@pg/protocol';
import { el, type HudTeil } from './typen.js';

const MAX = 5;

function melde(text: string, klasse = ''): void {
  const liste = el<HTMLUListElement>('#meldungen');
  const li = document.createElement('li');
  li.textContent = text;
  if (klasse) li.className = klasse;
  liste.appendChild(li);
  while (liste.children.length > MAX) liste.removeChild(liste.children[0]!);
  setTimeout(() => li.remove(), 4200);
}

export const meldungen: HudTeil = {
  name: 'meldungen',
  bauen() {
    el<HTMLUListElement>('#meldungen').innerHTML = '';
  },
  ereignis(_u, e: Ereignis) {
    switch (e.art) {
      case 'beute-gefallen':
        melde(e.name, e.seltenheit);
        break;
      case 'beute-aufgehoben':
        if (e.durchBegleiter) melde(`Krümel: ${e.name}`);
        break;
      case 'stufe-erreicht':
        melde(`Stufe ${e.stufe}`, 'stufe');
        break;
      case 'faehigkeit-freigeschaltet':
        melde(`Neu: ${e.name}`, 'stufe');
        break;
    }
  },
};
